import { useLocation, useNavigate } from "react-router-dom";

const ServerError = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const status = location.state?.status || Number(sessionStorage.getItem("apiErrorStatus"));

    const title = status === 503 ? "Service unavailable" : "Something went wrong";
    const subtitle =
        status === 503
            ? "The service is temporarily unavailable. Please try again later."
            : "An internal server error occurred. Please try again later.";

    return (
        <div className="min-h-screen flex items-center justify-center bg-[#f7f8fa] px-6">
            <div className="max-w-[520px] w-full rounded-xl bg-white shadow-md p-10 text-center">
                <h1 className={`${status ? "text-[48px]" : "text-[28px]"} font-semibold text-[#BC2525]`}>{status || "ERR_NETWORK"}</h1>
                <h2 className="text-[28px] font-semibold text-[#111827] mt-2">{title}</h2>
                <p className="text-[16px] text-[#6B7280] mt-4">{subtitle}</p>

                <div className="flex gap-3 justify-center mt-8">
                    <button
                        className="px-5 py-2 rounded bg-[#BC2525] text-white"
                        onClick={() => window.location.reload()}
                    >
                        Retry
                    </button>
                    {/* <button
                        className="px-5 py-2 rounded border border-[#D1D5DB]"
                        onClick={() => navigate("/home")}
                    >
                        Go to Home
                    </button> */}
                </div>
            </div>
        </div>
    );
};

export default ServerError;